import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	margin: 1% 0 0 0;
	padding: 0 2%;
`;

export const FilterWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
  	justify-content: flex-start;
  	margin:5px 10px 10px 0;
  	> div {
		> div {
        border-radius: 0;
		}
  .ap-button-main {
    height: 32px;
  }
`;

export const DateRangeWrapper = styled.div`
	.ap-month-picker > div {
		border: 1px solid #cccccc;
	}
	.ap-month-picker > div:hover {
		border: 1px solid ${colors.black};
	}
	.ap-month-picker > div:nth-child(2) {
		top: 24%;
		left: 16%;
	}
`;

export const Breadcrumbs = styled.div`
	display: flex;
	align-items: center;
	font-weight: 500;
	font-size: 12px;
	letter-spacing: 0.3px;
	color: ${colors.grey6};
	padding-bottom: 10px;
	span {
		cursor: pointer;
		font-size: 12px;
	}
	span:hover {
		cursor: pointer;
		color: ${colors.grey9};
	}
`;
